import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {Iterable} from 'immutable';
import classnames from 'classnames';
import {Icon, Text} from '@albert-io/atomic';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import './passage.scss';

export default class Passage extends React.Component {
  static propTypes = {
    content: PropTypes.oneOfType([ImmutablePropTypes.map, PropTypes.object])
  };

  state = {
    isExpanded: false
  };

  toggleIsExpanded = () =>
    this.setState((state) => ({
      isExpanded: !state.isExpanded
    }));

  getContent() {
    return Iterable.isIterable(this.props.content) ? this.props.content.toJS() : this.props.content;
  }

  hasContent(line) {
    return /[^\s]/.test(line);
  }

  getFormattedLines({text, ignoreWhiteSpace}) {
    if (text) {
      const splitText = text.split(/[\n\r]/);
      return ignoreWhiteSpace ? splitText.filter(this.hasContent) : splitText;
    }
  }

  makeLines({lines, hideLineNumbers, excludeWhiteSpace}) {
    let wasPrevLineEmpty = false;
    let lineNumber = 0;
    if (lines) {
      return lines.map((line, i) => {
        const isEmptyLine = !this.hasContent(line);
        if (wasPrevLineEmpty && isEmptyLine) {
          return;
        }
        wasPrevLineEmpty = isEmptyLine;
        return (
          <PassageLine
            key={i}
            hideLineNumbers={hideLineNumbers}
            lineNumber={excludeWhiteSpace && isEmptyLine ? null : ++lineNumber}
            line={isEmptyLine ? '\u00a0' : line}
          />
        );
      });
    }
  }

  render() {
    const {excludeWhiteSpace, hideLineNumbers, ignoreWhiteSpace, text} = this.getContent();
    const {isExpanded} = this.state;
    const lines = this.getFormattedLines({text, ignoreWhiteSpace});
    return (
      <div className='passage-supplement'>
        <button
          onClick={this.toggleIsExpanded}
          className={classnames('passage-supplement__toggle', {
            'passage-supplement__toggle--expanded': isExpanded
          })}
        >
          <Icon
            icon={isExpanded ? 'caret-down' : 'caret-right'}
            className='passage-supplement__icon'
          />
          {isExpanded ? 'Hide' : 'Show'} Passage
        </button>
        {isExpanded && (
          <ul className='passage-supplement__passage'>
            {this.makeLines({
              lines,
              hideLineNumbers,
              excludeWhiteSpace
            })}
          </ul>
        )}
      </div>
    );
  }
}

const PassageLine = ({hideLineNumbers, lineNumber, line}) => (
  <li className='passage-supplement-line'>
    {!hideLineNumbers && (
      <Text bold size='m' emphasis='low' className='passage-supplement-line__number'>
        {lineNumber}
      </Text>
    )}
    <MarkdownRendererV2 text={line} />
  </li>
);

PassageLine.propTypes = {
  hideLineNumbers: PropTypes.bool,
  lineNumber: PropTypes.number,
  line: PropTypes.string
};
